// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.synopsis-main {
  /* padding-top: 6.25rem; */
}
.synopsis {
  height: auto;
  margin: 2rem 0 0 0;
  width: 100%;
  display: flex;
  gap: 3rem;
  align-items: flex-start;
  padding-bottom: 2rem;
  /* margin: 70.313rem auto; */
  /* height: max-content; */
  /* align-items: center; */
  /* padding-bottom: 6.25rem; */
  /* align-items: baseline; */
}
h1.ant-typography,
.ant-typography h1 {
  font-size: 1.5rem !important;
}
h4.ant-typography,
.ant-typography h4 {
  font-size: 1.25rem;
}
.synopsis .left {
  width: 15%;
  /* background-color: var(--primary-color); */
  background-color: white;
  display: flex;
  border-radius: 0.625rem;
  flex-direction: column;
  /* justify-content: space-between; */
  /* height: max-content; */
  /* min-height: 93vh; */
  height: max-content !important;
  text-align: center;
  /* padding: 1.875rem 0; */
  /* position: fixed; */
}
.box h5 {
  color: white !important;
  /* color: var(--primary-color) !important; */
}
.box {
  background-color: var(--primary-color);

  /* background-color: white; */
  border-radius: 0.625rem;
  width: 80%;
  margin: 1.2rem auto;
  text-align: center;
  padding: 0.625rem 0;
  /* min-height: 6.25rem; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 7rem;
}
.synopsis .segment-box {
  border-radius: 0.625rem;
  min-height: 7.7rem;
  padding: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  box-shadow: var(--boxShadow);
}
.synopsis .segment-box .section {
  display: flex;
  flex-wrap: wrap;
}

.synopsis .segment-box .content {
  margin: 0 0.625rem;
}
.center {
  justify-content: center !important;
}
.synopsis .segment-box h5,
.synopsis .segment-box span {
  font-size: 0.813rem;
}
.synopsis .segment-box .head {
  color: #778899 !important;
  font-size: 1rem !important;
}
/* .box h5, */
.synopsis .segment-box h5,
.synopsis .segment-box span {
  color: black !important;
  font-weight: normal;
  margin: 0.313rem 0;
}
.synopsis .right h2 {
  text-align: center;
}

.synopsis .right {
  width: 85%;
  /* padding: 1.875rem; */
  /* margin-left: 33.75rem; */
}
.synopsis .synopsis-charts {
  text-align: center;
}
.mostRecentCampaigns {
  width: 95%;
}
.mostRecentCampaigns h1 {
  font-size: 1.5rem !important;
  margin: -2rem 0;
}
.segmentation .graph-card canvas {
  /* height: 63.125rem !important; */
}
.segmentTransitionSelection
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  border-radius: 0.5rem;
  background-color: var(--primary-color);
  color: white;
}
/* .segmentTransitionSelection svg {
  color: white;
} */
.topCampaigns {
  margin-bottom: 5rem !important;
}
.segmentation,
.recent-campaign {
  /* height: 87vh; */
}
.recent-campaign h1 {
  font-size: 1.5rem !important;
}
.synopsis-main .inner-content h1 {
  margin: 1.875rem 0;
}

.synopsis-main .inner-content {
  width: 95%;
  /* margin: 1.875rem auto; */
  /* margin-bottom: 1rem !important; */
}
.inner-content .ant-table-cell {
  padding: 0.8rem;
}
.inner-content .ant-table-tbody {
  font-size: 1rem !important;
}
.cross-campaign .graph-card {
  margin-bottom: 2.5rem;
}

.report-filter > .graph-card th {
  font-size: 14px;
}
.report-filter > .graph-card tr {
  font-size: 12px;
}
.filter > .graph-card .cross-campaign h1 {
  font-size: 1.5 !important;
}
.cross-campaign .channel-table .ant-table-thead > tr > th {
  text-align: center;
}
.cross-campaign .ant-table-thead > tr > th,
.cross-campaign .ant-table-tbody > tr > td {
  background-color: transparent;
  color: #778899;
  border: none;
}

.cross-campaign .ant-table-tbody > tr > td {
  font-size: 0.75rem;
}
.cross-campaign > * {
  margin-right: 0 !important;
}
.campaign-table .ant-table-thead > tr > th {
  background-color: transparent;
  border: none;
  font-size: 1rem;
  text-align: center;
}
.campaign-table .ant-table-tbody > tr > td {
  background-color: transparent;
  color: #778899;
  border: none;
  text-align: center;
  /* border-color: black; */
}

.cross-campaign .head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.customer-stats {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin: 1.875rem 0;
  gap: 1.25rem;
}

.customer-stats .green-card h4 {
  font-weight: 400;
}

.customer-stats .green-card h2,
.customer-stats .green-card h4 {
  margin: 0;
  color: white !important;
}

.customer-stats .green-card {
  background-color: var(--primary-color);
  border-radius: 0.625rem;
  width: 43.125rem;
  padding: 0.313rem 1.25rem;
}

.area-chart .graph-card h4 {
  color: var(--primary-color) !important;
  margin-bottom: 1.25rem;
  text-align: center;
}
.area-chart .months {
  margin: 2.5rem 0;
}

.response-rate .response-card {
  background-color: white;
  color: #778899;
  box-shadow: var(--boxShadow);
  text-align: center;
  cursor: pointer;
  font-weight: 700;
  font-size: 1.25rem;
  padding: 1.25rem;
  border-radius: 1rem;
  min-height: 24.375rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.response-rate .response-card .head {
  color: black;
}

.campaign-carousel {
  margin: 2rem 0;
}

.recent-campaign {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.response-rate {
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.circle {
  width: 1rem !important;
  height: 1rem !important;
  border-radius: 50% !important;
  margin-right: 0.625rem !important;
}

.campaign-box {
  background-color: white !important;
  min-height: 14rem !important;
}
.campaign-box .head {
  color: black !important;
  font-weight: normal !important;
}

.campaign-box h5 {
  color: #778899 !important;
  margin: 0.5rem 0 !important;
}

.campaign-table-flex {
  display: flex;
}
.campaign-table-flex img {
  margin-right: 1.25rem;
  object-fit: contain;
  filter: drop-shadow(0.125rem 0.125rem 0.125rem hsl(0deg 0% 0%/0.1));
}

.campaign-table .ant-progress-inner {
  background-color: transparent;
}
.campaign-table .ant-progress-line {
  width: 50% !important;
}
.campaign-table .ant-progress-bg.ant-progress-bg {
  height: 1.25rem !important;
  border-radius: 0 !important;
}
.campaign-table {
  margin: 3.125rem 0;
}
.campaignModal .ant-modal-content {
  padding: 0.625rem !important;
  background: #eaeaea;
  min-height: 37.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/synopsis.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,sCAAsC;;EAEtC,6BAA6B;EAC7B,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA,aAAa;AACb;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;;;EAGE,qBAAqB;EACrB,sCAAsC;EACtC,YAAY;AACd;AACA;;GAEG;AACH;EACE,8BAA8B;AAChC;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".synopsis-main {\n  /* padding-top: 6.25rem; */\n}\n.synopsis {\n  height: auto;\n  margin: 2rem 0 0 0;\n  width: 100%;\n  display: flex;\n  gap: 3rem;\n  align-items: flex-start;\n  padding-bottom: 2rem;\n  /* margin: 70.313rem auto; */\n  /* height: max-content; */\n  /* align-items: center; */\n  /* padding-bottom: 6.25rem; */\n  /* align-items: baseline; */\n}\nh1.ant-typography,\n.ant-typography h1 {\n  font-size: 1.5rem !important;\n}\nh4.ant-typography,\n.ant-typography h4 {\n  font-size: 1.25rem;\n}\n.synopsis .left {\n  width: 15%;\n  /* background-color: var(--primary-color); */\n  background-color: white;\n  display: flex;\n  border-radius: 0.625rem;\n  flex-direction: column;\n  /* justify-content: space-between; */\n  /* height: max-content; */\n  /* min-height: 93vh; */\n  height: max-content !important;\n  text-align: center;\n  /* padding: 1.875rem 0; */\n  /* position: fixed; */\n}\n.box h5 {\n  color: white !important;\n  /* color: var(--primary-color) !important; */\n}\n.box {\n  background-color: var(--primary-color);\n\n  /* background-color: white; */\n  border-radius: 0.625rem;\n  width: 80%;\n  margin: 1.2rem auto;\n  text-align: center;\n  padding: 0.625rem 0;\n  /* min-height: 6.25rem; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 7rem;\n}\n.synopsis .segment-box {\n  border-radius: 0.625rem;\n  min-height: 7.7rem;\n  padding: 0.625rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n  box-shadow: var(--boxShadow);\n}\n.synopsis .segment-box .section {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.synopsis .segment-box .content {\n  margin: 0 0.625rem;\n}\n.center {\n  justify-content: center !important;\n}\n.synopsis .segment-box h5,\n.synopsis .segment-box span {\n  font-size: 0.813rem;\n}\n.synopsis .segment-box .head {\n  color: #778899 !important;\n  font-size: 1rem !important;\n}\n/* .box h5, */\n.synopsis .segment-box h5,\n.synopsis .segment-box span {\n  color: black !important;\n  font-weight: normal;\n  margin: 0.313rem 0;\n}\n.synopsis .right h2 {\n  text-align: center;\n}\n\n.synopsis .right {\n  width: 85%;\n  /* padding: 1.875rem; */\n  /* margin-left: 33.75rem; */\n}\n.synopsis .synopsis-charts {\n  text-align: center;\n}\n.mostRecentCampaigns {\n  width: 95%;\n}\n.mostRecentCampaigns h1 {\n  font-size: 1.5rem !important;\n  margin: -2rem 0;\n}\n.segmentation .graph-card canvas {\n  /* height: 63.125rem !important; */\n}\n.segmentTransitionSelection\n  .ant-select-disabled.ant-select:not(.ant-select-customize-input)\n  .ant-select-selector {\n  border-radius: 0.5rem;\n  background-color: var(--primary-color);\n  color: white;\n}\n/* .segmentTransitionSelection svg {\n  color: white;\n} */\n.topCampaigns {\n  margin-bottom: 5rem !important;\n}\n.segmentation,\n.recent-campaign {\n  /* height: 87vh; */\n}\n.recent-campaign h1 {\n  font-size: 1.5rem !important;\n}\n.synopsis-main .inner-content h1 {\n  margin: 1.875rem 0;\n}\n\n.synopsis-main .inner-content {\n  width: 95%;\n  /* margin: 1.875rem auto; */\n  /* margin-bottom: 1rem !important; */\n}\n.inner-content .ant-table-cell {\n  padding: 0.8rem;\n}\n.inner-content .ant-table-tbody {\n  font-size: 1rem !important;\n}\n.cross-campaign .graph-card {\n  margin-bottom: 2.5rem;\n}\n\n.report-filter > .graph-card th {\n  font-size: 14px;\n}\n.report-filter > .graph-card tr {\n  font-size: 12px;\n}\n.filter > .graph-card .cross-campaign h1 {\n  font-size: 1.5 !important;\n}\n.cross-campaign .channel-table .ant-table-thead > tr > th {\n  text-align: center;\n}\n.cross-campaign .ant-table-thead > tr > th,\n.cross-campaign .ant-table-tbody > tr > td {\n  background-color: transparent;\n  color: #778899;\n  border: none;\n}\n\n.cross-campaign .ant-table-tbody > tr > td {\n  font-size: 0.75rem;\n}\n.cross-campaign > * {\n  margin-right: 0 !important;\n}\n.campaign-table .ant-table-thead > tr > th {\n  background-color: transparent;\n  border: none;\n  font-size: 1rem;\n  text-align: center;\n}\n.campaign-table .ant-table-tbody > tr > td {\n  background-color: transparent;\n  color: #778899;\n  border: none;\n  text-align: center;\n  /* border-color: black; */\n}\n\n.cross-campaign .head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.customer-stats {\n  display: flex;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n  margin: 1.875rem 0;\n  gap: 1.25rem;\n}\n\n.customer-stats .green-card h4 {\n  font-weight: 400;\n}\n\n.customer-stats .green-card h2,\n.customer-stats .green-card h4 {\n  margin: 0;\n  color: white !important;\n}\n\n.customer-stats .green-card {\n  background-color: var(--primary-color);\n  border-radius: 0.625rem;\n  width: 43.125rem;\n  padding: 0.313rem 1.25rem;\n}\n\n.area-chart .graph-card h4 {\n  color: var(--primary-color) !important;\n  margin-bottom: 1.25rem;\n  text-align: center;\n}\n.area-chart .months {\n  margin: 2.5rem 0;\n}\n\n.response-rate .response-card {\n  background-color: white;\n  color: #778899;\n  box-shadow: var(--boxShadow);\n  text-align: center;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 1.25rem;\n  padding: 1.25rem;\n  border-radius: 1rem;\n  min-height: 24.375rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.response-rate .response-card .head {\n  color: black;\n}\n\n.campaign-carousel {\n  margin: 2rem 0;\n}\n\n.recent-campaign {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.response-rate {\n  /* min-height: 100vh; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.circle {\n  width: 1rem !important;\n  height: 1rem !important;\n  border-radius: 50% !important;\n  margin-right: 0.625rem !important;\n}\n\n.campaign-box {\n  background-color: white !important;\n  min-height: 14rem !important;\n}\n.campaign-box .head {\n  color: black !important;\n  font-weight: normal !important;\n}\n\n.campaign-box h5 {\n  color: #778899 !important;\n  margin: 0.5rem 0 !important;\n}\n\n.campaign-table-flex {\n  display: flex;\n}\n.campaign-table-flex img {\n  margin-right: 1.25rem;\n  object-fit: contain;\n  filter: drop-shadow(0.125rem 0.125rem 0.125rem hsl(0deg 0% 0%/0.1));\n}\n\n.campaign-table .ant-progress-inner {\n  background-color: transparent;\n}\n.campaign-table .ant-progress-line {\n  width: 50% !important;\n}\n.campaign-table .ant-progress-bg.ant-progress-bg {\n  height: 1.25rem !important;\n  border-radius: 0 !important;\n}\n.campaign-table {\n  margin: 3.125rem 0;\n}\n.campaignModal .ant-modal-content {\n  padding: 0.625rem !important;\n  background: #eaeaea;\n  min-height: 37.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
